module.exports = __webpack_public_path__ + "img/folder1.6846406c.png";